import React, { useEffect, useState } from "react";
import { api, API, fmtDate } from "@/lib/api";
import { toast } from "sonner";
import { Eye, Download, X } from "lucide-react";

const STATUS = ["Draft", "Menunggu Pembayaran", "Menunggu Verifikasi", "Dokumen Perlu Diperbaiki", "Terverifikasi", "Dijadwalkan Asesmen", "Selesai", "Ditolak"];
const PSTATUS = ["Menunggu Pembayaran", "Menunggu Verifikasi", "Terverifikasi", "Ditolak"];

export default function AdminApplicants() {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);
  const load = () => api.get("/registrations").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const updateStatus = async (id, field, value) => {
    try {
      await api.put(`/registrations/${id}`, { [field]: value });
      toast.success("Status diperbarui"); load();
      if (sel?.id === id) setSel(s => ({ ...s, [field]: value }));
    } catch (err) { toast.error(err.response?.data?.detail || "Gagal memperbarui status"); }
  };
  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold text-emerald-950 mb-8">Pendaftar</h1>
      <div className="bg-white rounded-2xl border border-slate-100 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-600">
            <tr>
              <th className="text-left px-4 py-3">No. Pendaftaran</th>
              <th className="text-left px-4 py-3">Nama</th>
              <th className="text-left px-4 py-3">Tanggal</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-left px-4 py-3">Pembayaran</th>
              <th className="text-right px-4 py-3">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {items.map(r => (
              <tr key={r.id} data-testid={`reg-row-${r.registration_number}`} className="border-t border-slate-100">
                <td className="px-4 py-3 font-mono text-emerald-950 font-bold">{r.registration_number}</td>
                <td className="px-4 py-3">{r.personal?.full_name}</td>
                <td className="px-4 py-3 text-slate-600">{fmtDate(r.created_at)}</td>
                <td className="px-4 py-3">
                  <select value={r.status} onChange={e => updateStatus(r.id, "status", e.target.value)} className="px-2 py-1 rounded border border-slate-200 text-xs">
                    {STATUS.map(s => <option key={s}>{s}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3">
                  <select value={r.payment_status} onChange={e => updateStatus(r.id, "payment_status", e.target.value)} className="px-2 py-1 rounded border border-slate-200 text-xs">
                    {PSTATUS.map(s => <option key={s}>{s}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => setSel(r)} className="inline-flex items-center gap-1 px-3 py-1.5 rounded bg-emerald-950 text-white text-xs font-bold"><Eye className="w-3 h-3" /> Lihat</button>
                  <a href={`${API}/registrations/${r.id}/pdf`} target="_blank" rel="noreferrer" className="ml-2 inline-flex items-center gap-1 px-3 py-1.5 rounded gold-gradient text-emerald-950 text-xs font-bold"><Download className="w-3 h-3" /> PDF</a>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="6" className="text-center py-10 text-slate-500">Belum ada pendaftar.</td></tr>}
          </tbody>
        </table>
      </div>
      {sel && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setSel(null)}>
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-auto" onClick={e => e.stopPropagation()}>
            <div className="p-6 border-b flex justify-between items-center"><h2 className="font-display font-extrabold text-xl">{sel.registration_number}</h2><button onClick={() => setSel(null)}><X className="w-5 h-5" /></button></div>
            <div className="p-6 space-y-4 text-sm">
              <pre className="bg-slate-50 rounded p-4 text-xs overflow-auto">{JSON.stringify({personal: sel.personal, work: sel.work, certification: sel.certification, documents: sel.documents, payment_proof_file_id: sel.payment_proof_file_id}, null, 2)}</pre>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
